import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Row, Col, Progress } from 'antd';

const { Title } = Typography;

const LevelSection = ({ title, items, showProgress }) => {
  const itemSum = items.reduce((acc, curr) => acc + parseFloat(curr.v), 0);

  return (
    <div className="border-b border-gray-200 py-4">
      <Row>
        <Col span={18}>
          <span className="text-xl text-gray-600 font-semibold">
            {title}
          </span>
        </Col>
        <Col span={6} style={{ textAlign: 'right' }}>
          <Title level={5}>{itemSum.toFixed(2)}%</Title>
        </Col>
      </Row>

      <div style={{ marginTop: 6 }}>
        {items.map((item, idx) => {
          // Convert to a percentage for the progress bar
          const percent =
            itemSum > 0 ? (parseFloat(item.v) / itemSum) * 100 : 0;

          return (
            <Row key={idx} style={{ padding: '4px 0 0 2px' }} align="middle" className={'my-4'}>
              <Col span={showProgress ? 8 : 18}>
                <div className="text-sm text-gray-500 font-medium">{item.k}</div>
              </Col>

              {showProgress && (
                <Col span={8}>
                  <Progress
                    percent={percent}
                    showInfo={false}
                    strokeColor="black"
                    trailColor="transparent"
                    strokeLinecap="round"
                    strokeWidth={12}
                    lineBorderRadius={8}
                    format={() => `${percent.toFixed(1)}%`}
                  />
                </Col>
              )}

              <Col
                span={showProgress ? 8 : 6}
                style={{ textAlign: 'right' }}
              >
                <div className="text-xs text-black font-medium">{item.v}</div>
              </Col>
            </Row>
          );
        })}
      </div>
    </div>
  );
};

LevelSection.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      k: PropTypes.string.isRequired,
      v: PropTypes.string.isRequired,
    })
  ).isRequired,
  showProgress: PropTypes.bool,
};

const Levels = ({ title, items, showProgress }) => {
  return (
    <div style={{ padding: '20px' }}>
        {title && (
            <div className="border-b border-gray-200 pb-2">
                <span className={'text-2xl font-semibold'}>{title}</span>
            </div>
        )}
        {items.map((section, index) => (
            <LevelSection
                key={index}
                title={section.label}
                items={section.values}
          showProgress={showProgress}
        />
      ))}
    </div>
  );
};

Levels.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      values: PropTypes.arrayOf(
        PropTypes.shape({
          k: PropTypes.string.isRequired,
          v: PropTypes.string.isRequired,
        })
      ).isRequired,
    })
  ).isRequired,
  showProgress: PropTypes.bool,
};

export default Levels;
